import * as QRCode from "qrcode";

export function createQRCode(url) {
  return new Promise((resolve, reject) => {
    QRCode.toCanvas(
      url,
      {
        color: {
          dark: "#000000ff",
          light: "#ffffff00",
        },
        margin: 1,
        scale: 1,
      },
      (err, canvas) => {
        if (err) {
          reject(err);
        } else {
          resolve(canvas);
        }
      },
    );
  });
}
